// extracted by mini-css-extract-plugin
export default {"wrapper":"CaptureVisa_style_wrapper__88m1+","rotate":"CaptureVisa_style_rotate__UEf1p"};